/**
 * Trạng thái của form
 */
export default {
  NotAutonomy: 0,
  AutonomyExceptProject: 1,
  Autonomy: 2,
};
